// These names match the eager shared stylesheet imported by global-rules.css.
const styles = {
  panel: 'ht-nav-launcher-panel',
  panelDark: 'ht-nav-launcher-panel-dark',
  content: 'ht-nav-launcher-content',
  panelDrop: 'ht-nav-launcher-panel-drop',
  panelLift: 'ht-nav-launcher-panel-lift',
  rowsIn: 'ht-nav-launcher-rows-in',
  scroll: 'ht-nav-launcher-scroll',
} as const

export default styles
